export const Separator = ({ className }: { className?: string }) => (
  <span
    className={`tiny-normal text-fg-muted leading-none align-middle h-4 mt-[2px] ${className}`}
  >
    ·
  </span>
);
